import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import { validateRequiredSelect } from '../validate';

const FRANCH_STATUSES = [
    { id: '', title: 'users.choose_status' },
    { id: 0, title: 'users.ACTIVE' },
    { id: 1, title: 'users.BLOCKED' },
];

const renderFranchStatusField = ({ input, meta: { touched, error }, i18n, ...custom }) => {
    const showError = touched && error;
    return (
        <div
            style={{
                borderBottom: showError ? '2px solid red' : '2px solid transparent',
                paddingBottom: 4,
            }}
        >
            <NativeSelect {...input} {...custom}>
                {FRANCH_STATUSES?.map((item, key) => (
                    <option key={key} value={item.id}>
                        {i18n.t(item.title)}
                    </option>
                ))}
            </NativeSelect>
        </div>
    );
};

export default ({ label, code }) => {
    const { i18n } = useTranslation();

    return (
        <Card>
            <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                    {i18n.t(label)}
                </Typography>
                <Field
                    name={code}
                    i18n={i18n}
                    component={renderFranchStatusField}
                    type="text"
                    validate={validateRequiredSelect}
                />
            </CardContent>
        </Card>
    );
};
